/* src/app/modules/search/components/doc-view/components/email-head/email-head.component.scss */
.subject {
  max-width: calc(100% - 10rem);
}
.subject .subject-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 35rem;
  display: inline-block;
}
/*# sourceMappingURL=email-head.component.css.map */
